// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1rRgs","left":"InfoRow_left__qQ3TF"};